var map = {
	"./addresses.graphql": [
		402
	],
	"./all_favorites.graphql": [
		401
	],
	"./baby_shops.graphql": [
		403
	],
	"./categories.graphql": [
		1001,
		44
	],
	"./favorites.graphql": [
		400
	],
	"./get_shared_cart.graphql": [
		853,
		1,
		0
	],
	"./get_shared_wishlist.graphql": [
		842,
		1,
		0
	],
	"./page.graphql": [
		871,
		1,
		0
	],
	"./products_paginate.graphql": [
		383
	],
	"./share_promocode.graphql": [
		846,
		1,
		0
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 924;
module.exports = webpackAsyncContext;